// Home.js
import React from 'react';
import './Home.css';
import headerImg from '../assets/images/header-img-grouped.png';
import infoImg from '../assets/images/info-img-01.png';
import raAnalytics from '../assets/images/riskadjustments-analytics_thumb.png';
import arrowDirRight from '../assets/images/arrow-right-circled.svg';

import Carousel from '../components/carousel';


function Home() {
  return (
    <section className='container-fluid p-0 has-fixed-header'>
      <div className='hero-section p-0 py-sm-4'>
        <div className='container h-100 header-hero-content'>
          <div className='row h-100'>
            <div className='w-100 h-100 header-hero-container'>
              <div className='header-hero-content h-100 col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                <h1 className='display-5 header-title mb-3'>Transforming
                  <br />
                  <span className='header-title title-itlaic'>Risk Adjustment</span> 
                  <br />
                  <span className='header-title title-light'>with</span>  Precision <span className='header-title title-light'>&</span> Insight.
                </h1>
                <button className='btn btn-secondary btn-lg rounded-pill mt-2'>Get Started</button>
              </div>

              <div className='header-image h-100 col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                <img src={headerImg} alt='header image' className='img-fluid' />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='container-fluid p-0 py-sm-4'>
        <div className='container'>
          <div className='row h-100 py-2 align-items-center justify-content-center'>

            <div className='col-lg-12 col-md-12 col-sm-12 d-flex flex-row xs-flex-column align-items-center justify-content-center'>
                <div className='row align-items-center'>
                    <div className='col-xs-12 col-sm-12 col-md-5 col-lg-4'>
                      <img src={infoImg} alt='info image' className='img-fluid' />
                    </div>

                    <div className='col-xs-12 col-sm-12 col-md-7 col-lg-8'>
                      <div className='info-content ms-3 ms-sm-0 col-md-10'>
                        <h4 className='text-primary display-8'>Why Choose Elevate?</h4>
                        <p className='text-dark'>
                          Elevate stands at the forefront of healthcare innovation, delivering cutting-edge risk adjustment solutions that combine advanced analytics, AI-driven insights, and a deep understanding of compliance requirements. 
                        </p>

                        <p className='text-dark'>
                          Elevate stands at the forefront of healthcare innovation, delivering cutting-edge risk adjustment solutions that combine advanced analytics, AI-driven insights, and a deep understanding of compliance requirements. 
                        </p>

                        <p className='text-dark'>
                          Elevate stands at the forefront of healthcare innovation, delivering cutting-edge risk adjustment solutions that.
                        </p>
                        <button className='btn btn-primary px-4 rounded-pill mt-2'>Learn more</button>
                      </div>
                      

                    </div>
                </div>
            </div>
            
          </div>
        </div>
      </div>

      <div className='container-fluid section-solutions-home'>
        <div className='container'>
          <div className='row h-100 py-2 align-items-center justify-content-center'>

          <div className='col-xs-12 col-sm-12 col-md-12 col-lg-4'>
                    <h3 className='display-5 text-primary m-0'>
                    Comprehensive<br/>
                    Risk Adjustment<br/>
                    Solutions
                    </h3>
                    <p className='text-black mt-2'>
                    Tailored for payers and providers to maximize accuracy and efficiency.
                    </p>
          </div>

                <div className='col-xs-12 col-sm-12 col-md-12 col-lg-8'>
                    <ul className='solutions-list__cards'>
                      <li className='solutions-list__card col-lg-4 col-md-4 col-xs-12 col-sm-12 theme-primary'>
                        <div className='card-body'>
                          <img src={raAnalytics} alt='risk adjustment analytics' className='img-fluid' />
                        </div>
                        <div className='card-footer'>
                          <a href='' className='card-footer__nav'>
                            <span className='nav-title'>Risk Adjustment<br/>Analytics</span>
                            <img src={arrowDirRight} alt='arrow direction right' className='img-fluid arrow-direction' />
                          </a>
                        </div>
                      </li>

                      <li className='solutions-list__card col-md-4 col-xs-12 col-sm-12 theme-secondary'>
                      <div className='card-body'>
                          <img src={raAnalytics} alt='risk adjustment analytics' className='img-fluid' />
                        </div>
                        <div className='card-footer'>
                          <a href='' className='card-footer__nav'>
                          <span className='nav-title'>NLP-Driven Medical<br/>Coding</span>
                            <img src={arrowDirRight} alt='arrow direction right' className='img-fluid arrow-direction' />
                          </a>
                        </div>
                      </li>

                      <li className='solutions-list__card col-md-4 col-xs-12 col-sm-12 theme-quaternary'>
                      <div className='card-body'>
                          <img src={raAnalytics} alt='risk adjustment analytics' className='img-fluid' />
                        </div>
                        <div className='card-footer'>
                          <a href='' className='card-footer__nav'>
                          <span className='nav-title'>Audit and Compliance<br/>Support</span>
                          <img src={arrowDirRight} alt='arrow direction right' className='img-fluid arrow-direction' />
                          </a>
                        </div>
                      </li>
                    </ul>
                </div>
            
          </div>
        </div>
      </div>

{/* Testimonials Section */}
      <div className='container-fluid section-testimonials'>
        <div className='container'>
          <div className='row h-100 py-2 align-items-center justify-content-center'>
            <h3 className='section-title'>Testimonials</h3>   
            <Carousel />
            
          </div>
        </div>
      </div>



    </section>
    



  );
}

export default Home;